export const getResponse = ({ data }: any) => data
